export const environment = {
  production: true,
  watermark: true,
  server: 'https://service.myuart.cn',
  account: 'https://account.openxiot.cn',
};
